import posthog from "posthog-js";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const posthogEnabled = import.meta.env.VITE_PUBLIC_POSTHOG_TOKEN && import.meta.env.VITE_REACT_APP_ENV !== "DEV";

// Track a page view whenever the user navigates to a new route
export const trackPageView = () => {
	if (posthogEnabled) {
		posthog.capture("$pageview", {
			page_path: window.location.pathname,
			page_name: window.location.pathname === "/" ? "Home" : window.location.pathname,

			$pathname: window.location.pathname,
			$current_url: window.location.href,
			$host: window.location.hostname,
		});
	}
};

// Identify the user and record their login event in PostHog.
// This mirrors the same fields sent to MixPanel so both tools stay consistent.
export const trackLogin = (
	user = {
		id: null,
		first_name: null,
		last_name: null,
		company_name: null,
		is_2fa_enabled: null,
		role: null,
	},
	authMethod = "unknown",
) => {
	if (posthogEnabled) {
		posthog.identify(String(user.id), {
			first_name: user.first_name,
			last_name: user.last_name,
			name: `${user.first_name} ${user.last_name}`,
			email: user.email ?? null,
			company_name: user.company_name,
			user_role: user.role,
			is_2fa_enabled: user.is_2fa_enabled,
		});

		posthog.capture("login", {
			auth_method: authMethod,
			$pathname: window.location.pathname,
			$current_url: window.location.href,
			$host: window.location.hostname,
		});
	}
};
// React hook that fires a page view every time the route changes.
export const usePostHogTrackPageViews = () => {
	const location = useLocation();

	useEffect(() => {
		if (posthogEnabled) {
			trackPageView();
		}
	}, [location]);
};
